import BackendService from './BackendService';

// Verifies trade-in credentials
const validateTradeInCredentials = async (
  credentials,
  tradeInManagerType,
  dealerId,
) => {
  const resp = await BackendService.post('/dealers/verify/tradeInCredentials', {
    body: { credentials, tradeInManagerType, dealerId },
  });
  if (resp.isValidCredentials) {
    return true;
  }

  throw new Error(
    'something went wrong when trying to validate the trade-in credentials',
  );
};

export default validateTradeInCredentials;
